import { ROUTES } from '@/common/constants/routes';
import { useGetFeatures } from '@/common/integrations/menhir/employee/features/features.hooks';
import { Redirect, Slot } from 'expo-router';

export default function BudgetApplicationsLayout() {
  const {
    features: { FF_BUDGET_WITH_APPLICATION },
  } = useGetFeatures();

  if (!FF_BUDGET_WITH_APPLICATION) {
    return <Redirect href={ROUTES.NOT_FOUND} />;
  }

  return <Slot />;
}
